import React, { useState } from 'react';

function DcsDashboard() {
  // State za preklop med "plan" in "reports"
  const [view, setView] = useState('plan');

  // Placeholder za prihodnji plan
  const comingSoonMessage = "PRIHAJA KMALU - 2025";

  // URL za poročilo
  const reportUrl = 'https://lookerstudio.google.com/embed/reporting/5c6e59d7-bf73-4bdd-be25-c30cf1f015b6/page/kIV1C';

  return (
    <div className="w-full min-h-screen flex flex-col bg-[#0F172A]">
      {/* Header section with golden gradient */}
      <div className="p-3 sm:p-4">
        <h1 className="text-xl sm:text-3xl font-extrabold mb-4 text-amber-300 tracking-wide">
          DIPLOMATIC AND CORPORATE SERVICES SLOVENIJA
        </h1>

        {/* Navigation buttons */}
        <div className="flex flex-col sm:flex-row sm:space-x-4 space-y-2 sm:space-y-0">
          <button
            className={`px-6 py-2 rounded-full font-medium transition-all duration-200 text-sm sm:text-base ${
              view === 'plan'
                ? 'bg-amber-400 text-gray-900 shadow-lg transform hover:scale-105'
                : 'bg-transparent border-2 border-amber-400 text-amber-400 hover:bg-amber-400/10'
            }`}
            onClick={() => setView('plan')}
          >
            Plan
          </button>
          <button
            className={`px-6 py-2 rounded-full font-medium transition-all duration-200 text-sm sm:text-base ${
              view === 'reports'
                ? 'bg-amber-400 text-gray-900 shadow-lg transform hover:scale-105'
                : 'bg-transparent border-2 border-amber-400 text-amber-400 hover:bg-amber-400/10'
            }`}
            onClick={() => setView('reports')}
          >
            Poročila
          </button>
        </div>
      </div>

      {/* Main content area */}
      <div className="flex-1 p-2 sm:p-3">
        <div className="w-full h-[calc(100vh-140px)] rounded-2xl overflow-hidden shadow-lg border border-amber-400/30 bg-[#0F172A]">
          {view === 'plan' && (
            <div className="w-full h-full flex items-center justify-center">
              <h2 className="text-xl sm:text-3xl font-bold text-amber-300 text-center px-4">{comingSoonMessage}</h2>
            </div>
          )}
          {view === 'reports' && (
            <iframe
              src={reportUrl}
              className="w-full h-full"
              frameBorder="0"
              style={{
                background: 'transparent',
                border: 'none',
              }}
              title="DCS Report"
              allowFullScreen
              sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default DcsDashboard;
